/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/alt-text */
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './styles.scss';
import { Image } from 'antd';
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import Icons from '../../../configs/icon.config';

interface CarouselProps {
  imageLinks?: any[];
}

function CustomCarousel({ imageLinks }: CarouselProps) {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <div className="py-8">
      <Carousel
        showArrows
        autoPlay
        showStatus={false}
        showIndicators={false}
        infiniteLoop
        showThumbs={false}
        swipeable
        useKeyboardArrows
        stopOnHover
        dynamicHeight
        className="carousel"
        transitionTime={1500}
        renderArrowPrev={(clickHandler: () => void) => {
          return (
            <span>
              {imageLinks!.length <= 1 ? (
                ''
              ) : (
                <button
                  style={{ position: 'absolute', left: 20, zIndex: 3 }}
                  color="primary"
                  className="bg-gray-300 text-2xl rounded-full p-2 top-[50%] translate-y-[-50%]"
                  onClick={clickHandler}
                >
                  {Icons.chevronLeft}
                </button>
              )}
            </span>
          );
        }}
        renderArrowNext={(clickHandler: () => void) => {
          return (
            <span>
              {imageLinks!.length <= 1 ? (
                ''
              ) : (
                <button
                  style={{ position: 'absolute', right: 20, zIndex: 3 }}
                  color="primary"
                  className="bg-gray-300 text-2xl rounded-full p-2 top-[50%] translate-y-[-50%]"
                  onClick={clickHandler}
                >
                  {Icons.chevronRight}
                </button>
              )}
            </span>
          );
        }}
      >
        {imageLinks?.map((imageLink, index) => (
          <Image
            key={index}
            height={isMobile ? 'auto' : 420}
            width={isMobile ? '100%' : 750}
            src={imageLink.image}
            alt={`Image ${index}`}
          />
        ))}
      </Carousel>
    </div>
  );
}

export default memo(CustomCarousel);
